import script from "./deviceTable.vue?vue&type=script&setup=true&lang=js"
export * from "./deviceTable.vue?vue&type=script&setup=true&lang=js"

import "./deviceTable.vue?vue&type=style&index=0&id=2468bd0e&lang=css"

const __exports__ = script;

export default __exports__